<template>
  <m-dialog ref="dlg" :isclose="true" @save="save" :fullscreen="true" title="Enrol Pengelola">
    <v-row row wrap justify="center" align="center">
      <v-col cols="12" sm="12" md="10" lg="8" xl="8">
        <v-form @submit.prevent data-vv-scope="form" lazy-validation>
          <v-card flat class="mt-4 mb-5 pb-5">
            <v-card-text class="pa-5 pt-0">
              <v-row wrap>
                <v-col cols="12" class="mt-5">
                  <v-row wrap>
                    <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="my-0 py-0">
                      <v-text-field
                        outlined
                        v-show="search && $vuetify.breakpoint.mdAndUp"
                        dense
                        v-model="textSearch"
                        clearable
                        placeholder="  Tulis pencarian"
                        append-icon="mdi-magnify"
                        append-icon-color="primary"
                        @click:append="search()"
                        @keyup.enter="search()"
                        @click:clear="(textSearch = null), search()"
                        label
                        single-line
                        hide-details
                      >
                        <template v-slot:prepend-inner>
                          <v-select
                            class="mt-n2 ml-n3"
                            background-color="grey lighten-4"
                            style="maxWidth: 120px;border:0px;border-top-right-radius:0px;border-bottom-right-radius:0px;border-right: none;"
                            dense
                            outlined
                            height="15"
                            single-line
                            hide-details
                            filled
                            autocomplete="false"
                            v-model="paramSearch"
                            :items="variablePencarian"
                            no-data-text="Data Tidak Tersedia"
                            data-vv-name="paramSearch"
                            data-vv-as="Pencarian"
                            v-validate="'required'"
                            :error-messages="errors.collect('form.paramSearch')"
                          >
                          </v-select>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="12" v-show="selectedItems.length > 0">
                      <m-alert show :info="`Anda telah memilih ` + selectedItems.length + ` Pengguna`"></m-alert>
                      <v-chip class="ma-1 selected-pengelola" v-for="item in selectedItems" :key="item.id" close @click:close="removeSelected(item)">
                        <v-avatar left>
                          <v-icon>mdi-account-circle</v-icon>
                        </v-avatar>
                        {{ item.name }}
                      </v-chip>
                      <br />
                    </v-col>
                    <v-col cols="12" sm="12" md="6" lg="6" xl="4" v-show="false">
                      <v-select
                        class="mx-2"
                        outlined
                        dense
                        autocomplete="false"
                        v-model="peran"
                        :items="itemPerans"
                        item-text="keterangan"
                        item-value="id"
                        return-object
                        placeholder="Semua Peran"
                        data-vv-name="peran"
                        data-vv-as="Peran"
                        label="Tambahkan sebagai"
                      >
                        <template slot="selection" slot-scope="data">
                          <span class="font-weight-bold caption">{{ data.item.keterangan }}</span>
                        </template>
                      </v-select>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="12">
                      <v-data-table v-model="selectedItems" :headers="headers" :items="itemKandidats" :items-per-page="15" item-key="id" show-select hide-default-footer>
                        <template v-slot:body="{ items }">
                          <tbody>
                            <tr v-for="item in items" :key="item.id">
                              <td>
                                <v-checkbox v-model="selectedItems" :value="item" style="margin:0px;padding:0px" hide-details />
                              </td>
                              <td class="font-weight-bold">{{ pVal(item, "name") }}</td>
                              <td class="blue--text text--darken-4">{{ pVal(item, "email") }}</td>
                              <td>{{ pVal(item, "nama_sekolah") }}</td>
                            </tr>
                          </tbody>
                        </template>
                        <template v-slot:footer>
                          <v-row wrap class="pb-3" v-if="page && page.last_page > 1">
                            <v-col :cols="$vuetify.breakpoint.smAndUp ? 2 : 3" class="text-left" align="center" justify="center">
                              <p class="caption font-weight-bold">{{ page.total }} &nbsp; Data ditemukan</p>
                            </v-col>
                            <v-col cols="8" v-if="$vuetify.breakpoint.smAndUp" class="text-center">
                              <v-pagination v-if="page.total" :key="page_key" v-model="current_page" :length="page.last_page" :total-visible="7" @input="change"></v-pagination>
                            </v-col>
                            <v-col :cols="$vuetify.breakpoint.smAndUp ? 2 : 9" v-if="page.from" class="text-right">
                              <p class="caption font-weight-bold">{{ page.from }} - {{ page.to }} dari {{ page.total }}</p>
                            </v-col>
                          </v-row>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </m-dialog>
</template>

<script>
import { ALERT_INFO } from "@/const";
export default {
  $_veeValidate: {
    validator: "new"
  },

  data() {
    return {
      showPeran: false,
      enroll: {},
      tipe: "",
      course_id: null,
      peran: null,
      modul_id: null,
      textSearch: "",
      itemKelases: [],
      itemKandidats: [],
      itemPerans: [],
      countMapelPilihan: 1,
      alert: ALERT_INFO,
      selectedItems: [],
      page: null,
      cp: 1,
      current_page: 0,
      jump_page: 0,
      selection: [],
      pagging: {},
      page_key: 0,
      totalPagination: [],
      paramSearch: null,
      variablePencarian: ["nama", "surel", "peran"],
      headers: [{ text: "Nama", align: "left", value: "nama" }, { text: "Surel", align: "left", value: "email" }, { text: "Sekolah", align: "left", value: "nama_sekolah" }]
    };
  },
  methods: {
    open() {
      this.textSearch = null;
      this.paramSearch = "nama";
      this.itemKandidats = [];
      this.selectedItems = [];
      this.page = null;
      this.loadKandidat();
      //this.peranKelas();

      let x = this.$refs.dlg.open();
      this.$validator.reset();
      return x;
    },

    removeSelected(item) {
      const tempSelected = this.selectedItems;
      const shallowCopyArray = Array.from(tempSelected);
      const index = shallowCopyArray.indexOf(item);
      if (index > -1) {
        shallowCopyArray.splice(index, 1);
      }
      this.selectedItems = shallowCopyArray;
    },

    // eslint-disable-next-line
    save() {
      this.selectedItems.forEach(item => {
        item.peran_kelas = {
          id: 2,
          keterangan: "Master Trainer"
        };
      });
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          return this.$store.dispatch("kelas/enrollPeserta", {
            instansi_id: this.instansi_id,
            kelas_id: this.kelas_id,
            obj: this.selectedItems
          });
        })
        .then(res => {
          this.$info("Simpan Data Berhasil");
          this.$refs.dlg.resolve();
          return res;
        })
        .catch(e => e);
    },

    search() {
      this.current_page = 1;
      this.cp = 1;
      this.loadKandidat();
    },

    // eslint-disable-next-line
    loadKandidat() {
      var selected = this.selectedItems;
      var params = {
        page: this.cp,
        kelas_id: this.kelas_id,
        peran_id: 3
      };
      if (this.textSearch) {
        params[this.paramSearch] = this.textSearch;
      }
      return this.$store
        .dispatch("user/getKandidatPengelola", {
          instansi_id: this.instansi_id,
          params: params
        })
        .then(res => {
          this.page = res;
          this.itemKandidats = res.data;
          this.selectedItems = [];
        })
        .then(() => {
          return (this.selectedItems = selected);
        })
        .catch(e => e);
    },

    // eslint-disable-next-line
    peranKelas() {
      return this.$store
        .dispatch("kelas/getPeran", {
          instansi_id: this.instansi_id
        })
        .then(res => {
          this.itemPerans = res.filter(peran => peran.id != 1);
        })

        .catch(e => e);
    },

    change() {
      if (this.current_page !== this.page.current_page) {
        this.cp = this.current_page;
        this.loadKandidat();
      }
    }
  },
  watch: {
    page(n) {
      if (n) {
        this.current_page = n.current_page;
        this.jump_page = n.current_page;
        this.page_key = Math.random();
        for (let i = 1; i <= n.last_page; i++) {
          this.totalPagination.push(i);
        }
      }
    },
    items() {
      this.current_page = this.page ? this.page.current_page : 0;
    }
  }
};
</script>
